class Bland {
    constructor(scene) {

        this.scene = scene;
        this.sprite = scene.physics.add.sprite(0,460, 'blank', 0)
            .setScale(2 )
            .setSize(1280, 8)
            .setCollideWorldBounds(true) 
            .setDepth(1)
            this.sprite.body.customBoundsRectangle.left = -500;
            this.sprite.body.customBoundsRectangle.right = 2000;

            this.collider = scene.physics.add.collider(
                scene.player.sprite,
                this.sprite,
                null,
                null,
                this
              );
    }



}

export default Bland; 